class GridConfigStateServiceClass {
  updateStateViewConfig(state, statusViewId, filterViewId, config) {
    const activeViews = state.userViewConfigurations[statusViewId];
    return {
      ...state,
      userViewConfigurations: {
        ...state.userViewConfigurations,
        [statusViewId]: {
          ...activeViews,
          [filterViewId]: [...config],
        },
      },
    };
  }
}

export const GridConfigStateService = new GridConfigStateServiceClass();
